export function getIsAuthenticated(state) {
  return state.isAuthenticated
}

export function getAuthToken(state) {
  return state.token
}

export function getPatientToken(state) {
  return state.patientToken
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/auth/getters.js
// module id = null
// module chunks = 